// utils/normalizeTheme.ts
import { createTheme, Theme } from "@mui/material/styles";

function _normalizeTheme(backendTheme: any) {
  const defaultSidebar = {
    background: "#f5f5f5",
    text: "#000000",
  };

  return createTheme({
    ...backendTheme,
    palette: {
      ...backendTheme?.palette,
      sidebar: {
        ...defaultSidebar,
        ...backendTheme?.palette?.sidebar,
      },
    },
  });
}

export const defaultSidebarPalette = {
    background: '#ffffff', // или любой другой безопасный дефолт
    text: '#000000',
    items: {
        background: 'transparent',
        text: '#000000',
    },
    selected: {
        background: '#e0e0e0',
        text: '#000000',
    },
    hover: {
        background: '#f5f5f5',
    },
};

const defaultMuiButton = {
    defaultProps: {
        disableElevation: true,
        variant: 'contained',
        size: 'medium',
    },
    styleOverrides: {
        root: {
            borderRadius: 8,
            textTransform: 'none',
            padding: '10px 20px',
            '&:hover': {
                opacity: 0.9,
            },
        },
        contained: {
            fontWeight: 700,
        },
        sizeLarge: {
            fontSize: '1.1rem',
        },
    },
};

/**
         root: ({ theme }: { theme: Theme }) => ({
          borderRadius: 8, // Скругление углов
          textTransform: 'none', // Отключение заглавных букв
          padding: '10px 20px',
          // Пример: изменение стилей при наведении (hover)
          '&:hover': {
            opacity: 0.9,
          },
        }),
 */

const components = {
    // Название компонента: Mui[Component]
    MuiButton: {
      // 1. Изменение пропсов по умолчанию для всех кнопок
      defaultProps: {
        disableElevation: true, // Всегда отключать тень
        variant: 'contained', // По умолчанию использовать Contained
        size: 'medium',       // По умолчанию размер Medium
      },
      // 2. Глобальное переопределение стилей
      styleOverrides: {
        // Слот 'root' - применяется к базовому элементу кнопки
        root: {
          borderRadius: 8, // Скругление углов
          textTransform: 'none', // Отключение заглавных букв
          padding: '10px 20px',
          // Пример: изменение стилей при наведении (hover)
          '&:hover': {
            opacity: 0.9,
          },
        },
        // Изменение стилей для конкретного варианта
        contained: {
          fontWeight: 700,
        },
        // Изменение стилей для конкретного размера
        sizeLarge: {
            fontSize: '1.1rem',
        }
      },
    },
}

export function normalizeTheme(rawTheme: any): Theme {
  const baseTheme = createTheme(rawTheme);
  return createTheme(baseTheme, {
    palette: {
      sidebar: {
        ...defaultSidebarPalette,
        ...rawTheme?.palette?.sidebar,
        item: {
          ...defaultSidebarPalette.items,
          ...rawTheme?.palette?.sidebar?.item,
        },
        selected: {
          ...defaultSidebarPalette.selected,
          ...rawTheme?.palette?.sidebar?.selected,
        },
        hover: {
          ...defaultSidebarPalette.hover,
          ...rawTheme?.palette?.sidebar?.hover,
        },
      },
    },
    components: {
      MuiButton: {
        ...defaultMuiButton,
        ...rawTheme?.components?.MuiButton,
      },
    },
  });
}

/**
 * import { createTheme, ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';

const customTheme = createTheme({
  components: {
    // Название компонента: Mui[Component]
    MuiButton: {
      // 1. Изменение пропсов по умолчанию для всех кнопок
      defaultProps: {
        disableElevation: true, // Всегда отключать тень
        variant: 'contained', // По умолчанию использовать Contained
        size: 'medium',       // По умолчанию размер Medium
      },

      // 2. Глобальное переопределение стилей
      styleOverrides: {
        // Слот 'root' - применяется к базовому элементу кнопки
        root: ({ theme }) => ({
          borderRadius: 8, // Скругление углов
          textTransform: 'none', // Отключение заглавных букв
          padding: '10px 20px',

          // Пример: изменение стилей при наведении (hover)
          '&:hover': {
            opacity: 0.9,
          },
        }),

        // Изменение стилей для конкретного варианта
        contained: {
          fontWeight: 700,
        },
        
        // Изменение стилей для конкретного размера
        sizeLarge: {
            fontSize: '1.1rem',
        }
      },
    },
    // Здесь можно переопределить другие компоненты...
  },
});

function App() {
  return (
    <ThemeProvider theme={customTheme}>
      <Button>
        Button
      </Button> // {/* Будет contained, без тени }
      <Button variant="outlined" size="large">
        Large Outlined Button
      </Button> // {/* Будет использовать стили 'outlined' и 'sizeLarge' }
    </ThemeProvider>
  );
}

*/